
@if (control) {
  <div class="flex justify-start items-center gap-x-3">
    <div class="relative">
      <label class="input-label" [for]="id+'_sub'">{{fullLabel}}
        <ng-content select="label"></ng-content>
      </label>
      <div class="relative shadow-sm">
        <input class="input disabled:bg-extend-grey" [id]="id+'_sub'" [formControl]="control" type="text" [readonly]="readonly ? 'readonly' : null" [autocomplete]="'new-'+id" [class.input-invalid]="!control.valid &amp;&amp; control.enabled &amp;&amp; control.touched" [placeholder]="label" [attr.aria-invalid]="!control.valid &amp;&amp; control.enabled &amp;&amp; control.touched" [attr.aria-describedby]="id+'_sub_error'" [matAutocomplete]="auto">
        <mat-autocomplete #auto="matAutocomplete">
          @if (dataObs$ | async; as searchResults) {
            @if (searchResults.length > 0) {
              @for (result of searchResults; track result) {
                <mat-option [value]="result" (click)="handleOptionSelect(result)">{{result}}</mat-option>
              }
            }
            @if (searchResults.length === 0) {
              <mat-option [value]="null">Keine Ergebnisse</mat-option>
            }
          }
        </mat-autocomplete>@if (!control.valid && control.enabled && control.touched) {
        <span class="input-invalid-hint" [id]="id+'_sub_error'">{{ control.value | inputErrorMessage:control }}</span>
      }
    </div>
  </div>
  @if (dataObsExecuting) {
    <div class="h-10 w-10">
      <ng-content></ng-content>
    </div>
  }
</div>
}